import { createAuthApi } from '@modeling/account';

function resolveDcAuthBaseUrl(): string {
  if (process.env.NODE_ENV !== 'production') {
    return process.env.REACT_APP_DC_AUTH_API_BASE_URL!;
  }
  return window.REACT_APP_DC_AUTH_API_BASE_URL;
}

export const dcAuthApi = createAuthApi(resolveDcAuthBaseUrl());
